import { RegistryWidgetsType } from '@rjsf/utils';
import { YamlWidget } from './yaml';
import { JSONWidget } from './json';

export const CustomWidgets: RegistryWidgetsType = {
  YamlWidget: YamlWidget,
  JSONWidget: JSONWidget,
};
